import { render, staticRenderFns } from "./bip-link.vue?vue&type=template&id=74c58606&scoped=true&"
import script from "./bip-link.vue?vue&type=script&lang=js&"
export * from "./bip-link.vue?vue&type=script&lang=js&"
import style0 from "./bip-link.vue?vue&type=style&index=0&lang=css&"
import style1 from "./bip-link.vue?vue&type=style&index=1&id=74c58606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c58606",
  null
  
)

export default component.exports